export default __webpack_public_path__ + "static/media/16.5b10efb9.png";